import axios from 'axios'
import fetch from 'api/fetch'
import config from 'config'
import app from 'utils/app'
import store from 'store'
import env from 'utils/clientEnv'
const isProd = process.env.NODE_ENV === 'production'

export default {
  /**
   * 埋点上报请求
   * @param {*} params 埋点参数
   */
  logPost(params) {
    try {
      const obj = params || {}
      axios
        .post(isProd ? config.path.statUrl : '/shop/flyHeart', {
          random: Date.now(),
          ...obj
        })
        .then(res => {})
        .catch(e => {})
    } catch (e) {
      console.log(e)
    }
  },

  /**
   * 埋点上报请求
   * @param {*} params 埋点参数
   */
  log(params) {
    this.logPost(params)
  },

  /**
   * 埋点上报请求,包含公共参数
   * @param {*} params 埋点参数
   */
  logAll(params = {}) {
    params.cfrom = this.resetParam(params.cfrom)
    params.event_id = this.resetParam(params.event_id)
    let temp = {
      ...params,
      ...store.state.track.params,
      taskType: params.taskType || 1
    }
    this.logPost(temp)

    // 如果在app中，则调用app的上报
    if (params.event_id) {
      let appTemp = {
        ...params,
        ...store.state.track.appParams,
        taskType: params.taskType || 1
      }
      app.webDataReportByApp(appTemp)
    }
  },
  /**
   * 动态处理埋点eventId参数，兼容ios官网APP
   */
  resetParam(param) {
    let tmp = (param + '').split('|') || []
    if (tmp.length > 1) {
      tmp.pop()
      tmp.push(env.isIOSVivoApp ? '190' : '077')
      param = tmp.join('|')
    }
    return param || ''
  },
  /**
   * 初始化认证信息,由于当前与用户认证相关的信息做了安全限制，脚本无法本地访问，需要从接口拉取
   */
  initAuthInfo() {
    return fetch({
      url: '/common/cookie'
    })
  },

  /**
   * 获取分享配置信息
   * @param {string} groupCode
   */
  getShareConfig(groupCode) {
    return fetch({
      url: '/tool/shareConfig',
      params: {
        groupCode
      }
    })
  },

  /**
   * 获取推荐购机分享配置
   */
  getRecommendConfig() {
    return fetch({
      url: '/recmmdPurchase/getConfig'
    })
  },

  /**
   * 获取微信接口调用签名信息
   */
  getWXConfig() {
    return fetch({
      url: '/tool/weiChatConfig',
      params: {
        url: location.href.split('#')[0]
      }
    })
  },

  /**
   * 判断用户是否已实名认证
   */
  isRealNameRegister() {
    return fetch({
      url: '/comment/isRealNameRegister',
      method: 'post'
    })
  },

  /**
   * 获取官网公共头尾信息
   */
  getCommonHF(params) {
    let prefix = process.env.NODE_ENV === 'production' ? '//www.vivo.com.cn' : ''
    return fetch({
      url: prefix + '/header/getHF',
      params: {
        clientId: 3,
        target: 'vivoShop',
        type: 'wap',
        wapShopType: 'member',
        ...params
      },
      withCredentials: false
    })
  },

  /**
   * 获取官网公共头尾信息
   */
  getCommonFW(params) {
    let prefix = process.env.NODE_ENV === 'production' ? '//www.vivo.com.cn' : ''
    return fetch({
      url: prefix + '/header/getFW',
      params: {
        clientId: '3',
        target: 'vivoShop',
        type: 'wap',
        wapShopType: 'member',
        ...params
      },
      withCredentials: false
    })
  },

  /**
   * 获取官网360数据信息
   */
  getThreeDimensionalData(params) {
    let prefix = process.env.NODE_ENV === 'production' ? '//www.vivo.com.cn' : ''
    return fetch({
      url: prefix + '/vivo/get3D',
      params: {
        ...params
      },
      withCredentials: false
    })
  },

  /**
   * 退出登录
   */
  logout() {
    return fetch({
      url: '/member/logout'
    })
  },

  /**
   * 获取csrfToken
   */
  getCsrfToken() {
    return fetch({
      url: '/my/token'
    })
  },
  /**
   * 获取高德地图key
   */
  getLbsKey() {
    return fetch({
      url: '/my/address/getLbsKey'
    })
  },
  /**
   * 获取推荐有礼配置
   * scene含义 1:订单详情页 2:支付成功页 3:评价完成页
   */
  getShareConfigReq(scene) {
    return fetch({
      url: '/commodityPoster/shareConfig/' + scene
    })
  }
}
